export default function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backface-visibility': 'hidden',
      '-webkit-backface-visibility': 'hidden',
    });
  }
  return $slideEl;
}



// WEBPACK FOOTER //
// ../src/shared/effect-target.js